import { type OrdersMachineGuard, type OrderWithIdAndWantedTime } from '../orders-machine.types';

// ─────────────────────────────────────────────────────────────────────────────

export function createOrdersMachineGuards<Order extends OrderWithIdAndWantedTime>() {
  const checkIfCanFetchMoreOrders: OrdersMachineGuard<Order> = ({ context }) =>
    context.canFetchMoreOrders;

  return {
    checkIfCanFetchMoreOrders,
  };
}
